export default {
    required: "Érték megadása kötelező",
    email: "Az érték nem érvényes e-mail cím",
    mask: "Az érték érvénytelen",
    maxValue: "A maximális érték {max}",
    maxLength: "A megengedett maximális hossz {max}",
    regex: "Az érték érvénytelen",
    server: {
        DELEGATES_NOT_ENABLED: "A meghatalmazottak nincsenek engedélyezve ehhez a partnerhez.",
        DELEGATE_DOES_NOT_EXIST: "A delegált nem létezik",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Nem frissíthet olyan delegáltat, aki nem Önhöz tartozik.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Nem törölhet olyan meghatalmazottat, aki nem Önhöz tartozik.",
        DELEGATE_ALREADY_EXISTS: "Már létezik egy, a feltételeknek megfelelő delegálási szabály.",
        DELEGATE_CANNOT_BE_SELF: "Nem adhatod hozzá magad meghatalmazottként.",
        IMPERSONATE_USER_NO_PERMISSIONS: "A(z) {email} felhasználó nem fér hozzá a DXC Gearhez, és a nevében nem lehet rendelést leadni.",
        INVALID_CART_ITEM: "Termék {product} nem engedélyezett",
        INVALID_USER_TYPE: "A felhasználó típusa nem alkalmazott",
        INVALID_EMPLOYMENT_STATUS: "A felhasználó nem aktív alkalmazott",
        USER_NOT_FOUND: "Felhasználó nem található",
        "Invalid user type": "Érvénytelen felhasználótípus",
        "User not found": "Felhasználó nem található"
    }
}